<template>
	<Col class="width-100 height-100">
		<AnalyticsTotalRunsGraphCard />
		<div class="mt-5 display-flex cards-container">
			<AnalyticsTopUsersCard />
			<AnalyticsTopFeaturesCard class="features-card" />
		</div>
	</Col>
</template>
<script>
import AnalyticsTopUsersCard from '@/components/Analytics/Cards/AnalyticsTopUsersCard.vue';
import AnalyticsTopFeaturesCard from '@/components/Analytics/Cards/AnalyticsTopFeaturesCard.vue';
import AnalyticsTotalRunsGraphCard from '@/components/Analytics/Cards/AnalyticsTotalRunsGraphCard.vue';

export default {
	name: 'AnalyticsDashboardMainContent',
	components: { AnalyticsTotalRunsGraphCard, AnalyticsTopFeaturesCard, AnalyticsTopUsersCard },
};
</script>
<style scoped lang="scss">
.cards-container[max-width~='720px'] {
	flex-direction: column;
	.features-card {
		margin-top: 20px;
	}
}
.cards-container[min-width~='720px'] {
	flex-direction: row;
	.features-card {
		margin-left: 20px;
	}
}
</style>
